import React, { FC, useEffect, useState } from 'react';
import { Button, Flex } from '@chakra-ui/react';

import { Dialog } from '@app/components/common/modals';
import { SwitchField, TextField } from '@app/components/common';
import { useQueryTable } from '@app/components/common/table/query-table';
import { WarehouseType } from '@app/api/models/distributor';
import { useApi } from '@app/hooks';

interface EditWarehouseTypeProps {
  open: boolean;
  setOpen(value: boolean): void;
  initial?: WarehouseType;
}

export const EditWarehouseType: FC<EditWarehouseTypeProps> = ({
  open,
  setOpen,
  initial,
}) => {
  const [value, setValue] = useState<string>(initial?.name || '');
  const [isActive, setIsActive] = useState<boolean>(initial?.is_active || false);
  const [loading, setLoading] = useState(false);
  const { refetch } = useQueryTable();
  const api = useApi();

  useEffect(() => {
    setValue(initial?.name || '');
    setIsActive(initial?.is_active || false);
  }, [initial]);

  const onSubmit = async () => {
    setLoading(true);
    if (initial?.id) {
      await api.distributors.updateWarehouseType({
        id: Number(initial.id),
        name: value,
        is_active: isActive,
      });
    } else {
      await api.distributors.createWarehouseType({
        name: value,
        is_active: true,
      });
    }
    setLoading(false);
    setOpen(false);
    refetch();
  };

  const onDelete = async () => {
    if (!initial?.id) {
      return;
    }
    setLoading(true);
    await api.distributors.deleteWarehouseType(Number(initial.id));
    setLoading(false);
    setOpen(false);
    refetch();
  };

  return (
    <Dialog
      title="Тип склада"
      open={open}
      onClose={() => setOpen(false)}
      loading={loading}
      actions={
        <Flex gap={2}>
          {!!initial && (
            <Button colorScheme="red" variant="outline" onClick={onDelete}>
              Удалить
            </Button>
          )}
          <Button onClick={onSubmit}>
            {!initial ? 'Добавить' : 'Изменить'}
          </Button>
        </Flex>
      }
    >
      <Flex mb={1} flexDirection="column" gap={4}>
        <TextField
          id="warehouse_type_name"
          label="Название"
          value={value}
          onChange={setValue}
        />
        {!!initial && (
          <SwitchField
            id="warehouse_type_is_active"
            label="Активен"
            value={isActive}
            onChange={setIsActive}
          />
        )}
      </Flex>
    </Dialog>
  );
};
